
<div class="data-pipe-widget" :type="type" :tabindex="tabindex" @click="handleClick($event)">
	<div class="data-pipe-widget-header flex-gap-8">
		<!--@slot Used for Header Data -->
		<slot name="data-header" />
	</div>
	<div class="data-pipe-widget-stats">
		<!-- @slot Used for Stats Data -->
		<slot name="stats" />
	</div>
	<div v-if="$slots['display-data']" class="data-pipe-widget-content">
		<!-- @slot Used for Default Slots -->
		<slot name="display-data" />
	</div>
	<div class="data-pipe-widget-footer">
		<!--@slot Used for Footer Data -->
		<slot name="data-footer" />
	</div>
</div>
